import { formatToHumanDate } from '@/common/functions/dateFormater';
import { LogEntry, LogMeta } from '../styles/Recruitment.styled';

const Logs = ({ data }) => {
	return (
		<div>
			{data?.map((log, idx) => (
				<LogEntry key={idx}>
					<LogMeta>
						<b>{log.user}</b> at <span>{formatToHumanDate(log.at)}</span>
					</LogMeta>
					<p>{log.event}</p>
				</LogEntry>
			))}
		</div>
	);
};

export default Logs;
